// extracted by mini-css-extract-plugin
export var deliveryRow = "_li-a";
export var fixedHeight = "_li-4";
export var freightLogo = "_li-9";
export var fullWidth = "_li-3";
export var priceColumn = "_li-5";
export var radioSelected = "_li-7";
export var radioUnselected = "_li-6";
export var selectedOption = "_li-2";
export var selectedOptionContainer = "_li-1";
export var selection = "_li-0";
export var tallSkeletonText = "_li-8";